import React from "react"
import { Box, Column, Columns, Control, Field, Input, Select, TextArea, Title } from "@allxsmith/bestax-bulma";

export const DepositSection = ({rental, onChange}) => {

  const paymentMethods = [
    {name: "", value: "blank"},
    {name: "Direct Debit", value: "direct_debit"},
    {name: "Card Payments", value: "card_payments"},
    {name: "BACS", value: "bacs"}
  ]

  const paymentIntervals = [
    {name: "", value: "blank"},
    {name: "Weekly", value: "weekly"},
    {name: "Two Weekly", value: "two_weekly"},
    {name: "Four Weekly", value: "four_weekly"},
    {name: "Monthly", value: "monthly"},
  ]

  return (
    <Box>
      <Title>Deposit & Initial Payment</Title>
      <Columns isMultiline>
        <Column>
          <Field className={"has-addons"}>
            <Control>
              <label className="label">Deposit</label>
              <Input
                  type="number"
                  name="deposit"
                  onChange={onChange}
                  value={rental.deposit}
                  required
              />
            </Control>
          </Field>
        </Column>
        <Column>
        <Field className={"has-addons"}>
          <Control>
            <label className="label">Deposit Taken</label>
            <Input
                type="number"
                name="customer_deposit_paid_amount"
                onChange={onChange}
                value={rental.customer_deposit_paid_amount}
                required
            />
          </Control>
        </Field>
        </Column>
        <Column>
            <Control>
              <Field>
                <label className="label">Deposit Paid Date</label>
                <Input
                  type="date"
                  name="deposit_paid_date"
                  onChange={onChange}
                  value={rental.deposit_paid_date}
                  required
                />
              </Field>
            </Control>
          </Column>
      </Columns>
      <Columns isMultiline>
        <Column>
          <Field className={"has-addons"}>
            <Control>
              <label className="label">Initial Payment</label>
              <Input
                  type="number"
                  name="initial_payment"
                  onChange={onChange}
                  value={rental.initial_payment}
                  required
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field className={"has-addons"}>
            <Control>
              <label className="label">Initial Payment Taken</label>
              <Input
                  type="number"
                  name="customer_initial_payment_paid_amount"
                  onChange={onChange}
                  value={rental.customer_initial_payment_paid_amount}
                  required
              />
            </Control>
          </Field>
        </Column>
        <Column>
            <Control>
              <Field>
                <label className="label">Initial Payment Paid Date</label>
                <Input
                  type="date"
                  name="initial_payment_date"
                  onChange={onChange}
                  value={rental.initial_payment_date}
                  required
                />
              </Field>
            </Control>
          </Column>
      </Columns>
      <Columns isMultiline>
        <Column>
          <label className="label">Customer Payment Method</label>
          <Select
            name={"payment_method"}
            value={rental.payment_method}
            onChange={onChange}
          >
            {paymentMethods.map(method => (
                <option key={method.value} value={method.value}>{method.name}</option>
            ))}
          </Select>
        </Column>
        <Column>
          <label className="label">Customer Payment Interval</label>
          <Select
            name={"customer_payment_interval"}
            value={rental.customer_payment_interval}
            onChange={onChange}
          >
            {paymentIntervals.map(interval => (
                <option key={interval.value} value={interval.value}>{interval.name}</option>
            ))}
          </Select>
        </Column>
      </Columns>
      <Columns isMultiline>
        <Column>
          <label className="label">Comments</label>
          <TextArea
            name={"deposit_comments"}
            value={rental.deposit_comments}
            onChange={onChange}
          />
        </Column>
      </Columns>
    </Box>
  );
}